import { userConstants } from '../_constants';
const initialState = {};
export function addCustomer(state = initialState, action) {
  switch (action.type) {
    case userConstants.CUSTOMER_REQUEST:
      return {
        ...state,
        addcustomer: false,
        requestedData: action.customer.Data,
      };
    case userConstants.CUSTOMER_SUCCESS:
      return {
        ...state,
        addcustomer: true,
        data: action.customer.data,
      };
    case userConstants.CUSTOMER_FAILURE:
      return {
        ...state,
        addcustomer: false,
        data: action.customer.data,
      };
    default:
      return state;
  }
}

export function uploadMedia(state = initialState, action) {
  switch (action.type) {
    case userConstants.UPLOAD_MEDIA_REQUEST:
      return {
        ...state,
        media: false,
        data: action.upload.data,
      };
    case userConstants.UPLOAD_MEDIA_SUCCESS:
      return {
        ...state,
        media: true,
        data: action.upload.data,
      };
    case userConstants.UPLOAD_MEDIA_FAILURE:
      return {
        ...state,
        media: false,
        data: action.upload.data,
      };
    default:
      return state;
  }
}

export function getIDType(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_ID_TYPE_REQUEST:
      return {
        ...state,
        getId: false,
        data: action.getId?.data,
      };
    case userConstants.GET_ID_TYPE_SUCCESS:
      return {
        ...state,
        getId: true,
        data: action.getId.data.response,
      };
    case userConstants.GET_ID_TYPE_FAILURE:
      return {
        ...state,
        getId: false,
        data: action.getId.data,
      };
    default:
      return state;
  }
}

export function getProfession(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PROFESSION_REQUEST:
      return {
        ...state,
        profession: false,
        data: action.profession?.data,
      };
    case userConstants.GET_PROFESSION_SUCCESS:
      return {
        ...state,
        profession: true,
        data: action.profession.data.response,
      };
    case userConstants.GET_PROFESSION_FAILURE:
      return {
        ...state,
        profession: false,
        data: action.profession.data,
      };
    default:
      return state;
  }
}
